import React from "react";
import RemainingCrypto from "../Components/RemainingCrypto/List";
import WinnerList from "../Components/WinnerList";
import StatisticsLinesCount from "../Components/StatisticsGraphs/StatisticsLinesCount";
import StatisticsGraphs from "../Components/StatisticsGraphs/Statistics";
import StatisticsWithFilter from "../Components/StatisticsGraphs/StatisticsWithFilter";
import SectionLabel from "../Components/SectionLabel";

const ChartsTab = () => {
  return (
    <>
      <SectionLabel>Analytics & charts</SectionLabel>

      <div style={{ marginBottom: 24 }}>
        <StatisticsWithFilter />
      </div>

      <div style={{ marginBottom: 24 }}>
        <RemainingCrypto />
      </div>

      <div style={{ marginBottom: 24 }}>
        <StatisticsLinesCount />
      </div>

      <div style={{ marginBottom: 24 }}>
        <StatisticsGraphs />
      </div>

      <div>
        <WinnerList />
      </div>
    </>
  );
};

export default ChartsTab;
